import { Route, mapToCanActivate } from '@angular/router';
import {
  AuthNGuard,
  AuthZGuard,
} from '@daas-consulting/security/authentication/frontend/utils';
import { ChildrensRoutes } from './children.route';
import {
  SecurityAuthenticationValidateRoute,
  SecurityAuthenticationAuthenticationCallbackRoute,
  SecurityAuthenticationGenerateQrCodeRoute,
  SecurityAuthenticationLogoutRoute,
  SecurityAuthenticationTurnOnRoute,
  SecurityAuthenticationUnauthorizedRoute,
  SecuritySigninRoute,
} from './routes';

export const AppRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  SecuritySigninRoute,
  SecurityAuthenticationAuthenticationCallbackRoute,
  SecurityAuthenticationLogoutRoute,
  SecurityAuthenticationGenerateQrCodeRoute,
  SecurityAuthenticationTurnOnRoute,
  SecurityAuthenticationValidateRoute,
  SecurityAuthenticationUnauthorizedRoute,
  {
    path: '',
    canActivateChild: [...mapToCanActivate([AuthNGuard]), AuthZGuard],
    children: [
      ...ChildrensRoutes,
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'sandbox/confirm-click',
    loadComponent: () =>
      import('./sandbox/confirm-click-sandbox.component').then(
        (c) => c.ConfirmClickSandboxComponent
      ),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
